
import React from 'react';

function Loading() {
  return <div style={{textAlign : 'center'}} >Envoi en cours...</div>;
}

export default Loading;

